import instantiationPromise from "@/library/promiseTool";
let {resolve:_resolveTemp ,reject:_rejectTemp, promise:promiseTemp} = instantiationPromise ();
let authorizeMogoApp = {
  doAuth() {
    if (window.MGWebkit == undefined) {
      window.setTimeout(() => { authorizeMogoApp.doAuto() }, 100);
      return promiseTemp;
    }
    window.MGWebkit.getUserInfo(result => {
      if (result['data']['token']) {
        _resolveTemp(result['data']);
      } else{
        _rejectTemp("未登录");
      }
    });
    return promiseTemp
  }
}

export default authorizeMogoApp



// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeMogoApp.js